var map = {
	"./anushka.webp": "fc0a",
	"./arjun.webp": "b68b",
	"./arsh.webp": "ca0e",
	"./ashwani.webp": "74d4",
	"./ayush.webp": "cdf1",
	"./bharat.webp": "715f",
	"./bhaskar.webp": "75b2",
	"./binayak.webp": "73cb",
	"./deepak.webp": "b0c7",
	"./kamal.webp": "de98",
	"./kamalp.webp": "943f",
	"./nand.webp": "1a0c",
	"./neha.webp": "f5ed",
	"./paras.webp": "7967",
	"./pooja.webp": "2938",
	"./pramod.webp": "696a",
	"./pranavi.webp": "5d08",
	"./priya.webp": "417e",
	"./priyanka.webp": "f97a",
	"./rohan.webp": "8eb5",
	"./saireddy.webp": "27be",
	"./shreya.webp": "ad9d",
	"./shubhangi.webp": "2eef",
	"./shubhank.webp": "3b1e",
	"./simran.webp": "e9cc",
	"./sivram.webp": "5357",
	"./sonakshi.webp": "db94",
	"./tushar.webp": "bb04",
	"./varsha.webp": "581c",
	"./vrij.webp": "68b6",
	"./yash.webp": "6723",
	"./yatin.webp": "2e2b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b270";